import * as actions from './slice'

const getContentTab = {
  eventName: 'reportingGetContent',
  onSuccess: [
    {
      action: actions.setContentTab,
      redux: true
    }
  ]
}
const getUsageTab = {
  eventName: 'reportingGetUsage',
  onSuccess: [
    {
      action: actions.setUsageTab,
      redux: true
    }
  ]
}

const getSkillBitesTab = {
  eventName: 'reportingGetSkillBites',
  onSuccess: [
    {
      action: actions.setSkillBitesTab,
      redux: true
    }
  ]
}

const getAccelerateReport = {
  eventName: 'accelerateGetReport',
  onSuccess: [
    {
      action: actions.setAccelerateTab,
      redux: true
    }
  ]
}

export {
  getContentTab,
  getUsageTab,
  getSkillBitesTab,
  getAccelerateReport
}
